import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import Text from '../Typography/Text/Text.js';

const Details = (_param)=>{
    var { title , subtitle , className , children , summaryAttributes  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "title",
        "subtitle",
        "className",
        "children",
        "summaryAttributes"
    ]);
    const [open, setOpen] = React.useState(false);
    return /*#__PURE__*/ React.createElement("details", swcHelpers.extends({}, rest, {
        open: open,
        className: classnames('details', className),
        onToggle: ()=>setOpen(!open)
    }), /*#__PURE__*/ React.createElement("summary", swcHelpers.extends({}, summaryAttributes, {
        className: "details__summary"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "details__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        width: 18,
        height: 18,
        name: open ? 'minus' : 'plus'
    })), /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        color: "primary"
    }, title), subtitle && /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        color: "text-secondary"
    }, "(", subtitle, ")")), /*#__PURE__*/ React.createElement("div", {
        className: "details__content"
    }, children));
};

export { Details as default };
//# sourceMappingURL=Details.js.map
